import type {} from '@redux-devtools/extension'; // required for devtools typing
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type UseParametreStoreType = {
  suppressionPayeur: boolean;
  setParametre: (parametre: Record<string, unknown>) => void;
};

const useParametreStore = create<UseParametreStoreType>()(
  devtools((set) => ({
    suppressionPayeur: false,
    setParametre: (parametre) => {
      set(parametre);
    },
  })),
);

export default useParametreStore;
